import axios from 'axios';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

const RegistrarObligaciones = () => {
  const { id } = useParams(); // ID del contrato
  const [observacion, setObservacion] = useState('');
  const navigate = useNavigate();

  const saveObligaciones = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post('/api/obligaciones/add', {
        contratoObjectId: id,
        observacion,
      });

      if (response.data.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Obligación registrada correctamente',
          showConfirmButton: false,
          timer: 1500,
        });

        setObservacion('');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'No se pudo registrar',
          text: response.data.message || 'Error inesperado',
        });
      }
    } catch (error) {
      console.error('Error al registrar la obligación:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'No se pudo guardar la obligación',
      });
    }
  };

  return (
    <div className="container-fluid py-5 px-5 shadow-lg rounded-4 bg-light mt-5 mb-5">
      <h1 className="mb-4">Registrar Obligación Contractual</h1>

      <form onSubmit={saveObligaciones}>
        <div className="row">

          {/* Observación */}
          <div className="col-md-12">
            <label className="form-label mt-4 mb-2">Actividad u Observación</label>
            <textarea
              className="form-control"
              rows="4"
              value={observacion}
              onChange={(e) => setObservacion(e.target.value)}
              placeholder="Describa la actividad u observación realizada"
              required
            ></textarea>
          </div>

          {/* Botones */}
          <div className="col-md-6 mt-4">
            <button type="submit" className="btn btn-success w-100">
              Registrar Actividad
            </button>
          </div>

          <div className="col-md-6 mt-4">
            <button
              type="button"
              className="btn btn-danger w-100"
              onClick={() => navigate(-1)}
            >
              Cancelar
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default RegistrarObligaciones;
